import Vue from 'vue';
import './lib/composition-api';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import './middleware';
import '@/assets/svg';
import 'element-ui/lib/theme-chalk/index.css';

import { aegis } from '@/utils/jmonitor';

aegis.infoAll();

Vue.use(ElementUI);

Vue.config.productionTip = false;

declare const window: any;

window.WEBAPP = new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
